module.exports = (angularModule) => {
  angularModule.directive('accountSelector', () => {
    return {
      scope: {
        'onChange': '=',
        'selected': '=',
        'props': '='
      },
      template: `
      <react-component 
        name="Select"
        watch-depth="value"
        props="getProps()"
        ></react-component>`,
      controller: ($scope, accountsService) => {
        $scope.accounts = [];
        $scope.isLoading = true;

        accountsService.listAccounts().then(resp => {
          $scope.accounts = resp.accounts.map(x => ({
            label: `${x.accountName} (${x.locationTotal})`,
            value: x.id
          }));
          $scope.isLoading = false;
        })

        $scope.getProps = () => {
          return $scope.mergedProps = ({
            ignoreCase: true,
            value: $scope.selected,
            options: $scope.accounts,
            onChange: $scope.onChange,
            isLoading: $scope.isLoading,
            ...$scope.props
          })
        }

      }
    }
  })
}
